// extracted by mini-css-extract-plugin
module.exports = {"shortcuts":"workspace-shortcuts_shortcuts__luMG5","icon":"workspace-shortcuts_icon__YOzg7"};